import './App.css';
import { rutasPortalMkt } from './routes';
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
      {rutasPortalMkt.map((ruta, index_ruta) => (
          <Route 
            key={index_ruta} 
            path={ruta.ruta} 
            element={ruta.component}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
